import { type CategoryCardFragmentFragment, graphql } from "@commerce-frontend/types";
import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import {
	Card,
	CardCategory,
	CardContent,
	CardHeading,
	CardHeadline,
	CardMedia,
	CardSubtitle,
	CardTitle,
	CardTitleIcon,
	CardTitleWrapper,
} from "@commerce-frontend/ui/components/Card/Card";
import type { HTMLAttributes } from "react";
import { AssetImage } from "~/components/AssetImage/AssetImage";

graphql(/* GraphQL */ `
	fragment CategoryCardFragment on Card {
		__typename
		id
		title
		category
		supportingText
		image {
			...ImageAsset
		}
		cardLink: link {
			url
			newTab
			hash
		}
	}
`);

type Props = {
	item: CategoryCardFragmentFragment;
} & HTMLAttributes<HTMLDivElement>;

export const CategoryCard = ({ item }: Props) => {
	return (
		<Card className="flex h-full shrink-0 flex-col lg:max-w-[400px]" variant="boxed">
			<CardMedia>
				<AssetImage
					data={item?.image}
					style={{ width: "100%", height: "auto" }}
					width="384"
					height="288"
					sizes="(min-width: 0px) 384px"
				/>
			</CardMedia>
			<CardContent>
				<CardHeading>
					{item.category && <CardCategory>{item.category}</CardCategory>}
					<CardHeadline>
						<CardTitleWrapper>
							<CardTitle>{item.title}</CardTitle>
							<CardTitleIcon>
								<Icon icon="arrow-right" />
							</CardTitleIcon>
						</CardTitleWrapper>
						{item.supportingText && <CardSubtitle>{item.supportingText}</CardSubtitle>}
					</CardHeadline>
				</CardHeading>
			</CardContent>
		</Card>
	);
};
